<div class="row">
  <div class="col-12 col-md-12">
    <section>
      <div class="row">
        <form class="container-style" [formGroup]="formCostCenterPrice">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="costCenterPriceModel.userNameCreate"
                [createDate]="costCenterPriceModel.createDate" [userNameUpdate]="costCenterPriceModel.userNameUpdate"
                [updateDate]="costCenterPriceModel.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row custom-padding">
            @if (loading) {
            <div class="col-12">
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [required]="true" [recovery]="true"
                [list]="listBranches" (onChangeSelect)="getBranch($event, true)">
              </app-custom-select>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-6">
              <app-custom-input-text [value]="codeNameClient" [labelText]="'Cliente'" [disabled]="true">
              </app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-6">
              <app-custom-input-text [value]="codeNameConstructionSite" [labelText]="'Obra'" [disabled]="true">
              </app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="costCenterId" [labelText]="'Centro de Costos'" [required]="true"
                [recovery]="true" [list]="listCostCenters" (onChangeSelect)="changeCostCenter($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'" [required]="true"
                [recovery]="true" [list]="listConcepts" (onChangeSelect)="changeConceptInvoicing($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6">
              <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
                [required]="true" [recovery]="true" [showExtraButton]="true" [titleExtraButton]="'Seleccionar Artículo'"
                [iconExtraButton]="'pi pi-external-link'" (clickExtraButton)="openArticleModal()"
                (onChangeSelect)="changeArticle([], $event)"></app-custom-autocomplete>
              <app-custom-modal #selectArticle [label]="'Nuevo'" [header]="'Selección de Articulos'"
                [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
                (selectedItems)="changeArticle($event)" hidden>
              </app-custom-modal>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3 col-12">
              <app-custom-input-number formControlName="quantityEspecialInvoicing" [labelText]="'Cant.'">
              </app-custom-input-number>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-12">
              <app-custom-select formControlName="rentalUnitId" [labelText]="'Unidad Alq.'" [list]="listRentalUnits">
              </app-custom-select>
            </div>
            <div class="checkbox-swIsInvoiced">
              <app-custom-checkbox formControlName="swIsInvoiced" [labelText]="'Se Factura'"
                (onChangeCheckBox)="changeSwIsInvoiced($event)">
              </app-custom-checkbox>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-12">
              <app-custom-select formControlName="swInvoiceUnitM2" [labelText]="'Unidad Fra.'" [required]="true"
                [list]="listInvoiceUnits" (onChangeSelect)="changeInvoiceUnit()">
              </app-custom-select>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-12">
              <app-custom-input-decimal formControlName="baseUnitValue" [labelText]="'Vr.Unitario Base'">
              </app-custom-input-decimal>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-12">
              <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'"
                (onChangeNumber)="changeUnitValue($event)">
              </app-custom-input-decimal>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-12">
              <app-custom-input-decimal formControlName="rateDiscount" [labelText]="'% Descuento'"
                [maxFractionDigits]="5" (onChangeNumber)="changeRateDiscount($event)">
              </app-custom-input-decimal>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-12">
              <app-custom-input-decimal [value]="discountValue" [labelText]="'Vr.Descuento'"
                [disabled]="true"></app-custom-input-decimal>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3 col-12">
              <app-custom-input-number formControlName="minimumQuantityService" [labelText]="'Cant.Min. a Facturar'">
              </app-custom-input-number>
            </div>
            }
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="blockForm" [variant]="undefined"
                (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</div>